import React, { Component } from 'react';
import { apiSendMedicalCare } from '../../Api/Contact/Contact';
import {
  HospitalisationStep1Template,
  HospitalisationStep2Template,
  HospitalisationStep3Template,
  HospitalisationStep4Template,
  HospitalisationStep5Template
} from '../../Templates';
import { apiGetPostalAddressOnly } from '../../Api/Profile/Profile';
import { isNumber, validateEmail } from '../../Validation';
import { connect } from 'react-redux';
import * as moment from 'moment';

const HospitalisationOptions = [
  { text: 'Médecine chirugicale', value: 'MC' },
  { text: 'Observation', value: 'PSY' },
  { text: 'Psychiatrie', value: 'OBS' },
  { text: 'Accouchement voie basse', value: 'ACCVB' },
  { text: 'Accouchement césarienne', value: 'ACCCES' },
  { text: 'Soins externes', value: 'SE' }
];
class Hospitalisation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responseApi:"",
      showCalendar: false,
      files: [],
      data: {
        admissionDate: null,
        hospitalisationNature: null,
        hospitalisationDuration: '',
        facilityName: '',
        adresse: '',
        cp: '',
        city: '',
        fax: '',
        tel: '',
        mail: '',
        codeDMT: ''
      },
      currentStep: 1,
      contentSquareParams:[
        "informations","beneficiaire","etablissement",'success'
      ],
      benificiaireList: props.profile,
      benificiairePicked: {
        name: '',
        value: null
      },
      showDropDown: false,
      addressDetails: null,
      optionAdressData: [],
      errorMessage: ''
    };
    this.debouncedOnChange = this.debounce(this.handleInputChange, 500);
    this.props.history.push({
      pathname: '/hospitalisation',
      search: `?category=${this.state.contentSquareParams[0] }`
    })
  }

  componentDidMount (){
    this.sendMedicalCareDemand()
  }

  async sendMedicalCareDemand(){
    const body ={
      "numeroFax": "01 23 45 67 89",
      "telephone": "01 23 45 67 89",
      "admissionDate": "2024-02-12T11:48:17.928Z",
      "admissionDuration": 0,
      "admissionCause": "cause admission",
      "hospitalizedPerson": {
        "name": this.props.user.lastName,
        "firstName": this.props.user.firstName,
        "type": "HOPITAL",
        "socialSecurityNumber": "1 99 12 34 567 890 12",
        "codeTiers": this.props.user.codeTiers
      },
      "hospitalName": "Hôpital Pitié-Salpêtrière"
    }
    const response = await apiSendMedicalCare(body);
    if (response.status == 410) {
        this.setState({
          responseApi: response.errors[0]
        });
    }

  }

  handleInputChange = async (event) => {
    // this.setState({ data: {...this.state.data, adresse: event}  });
    const res = await apiGetPostalAddressOnly(this.state.data.adresse);
    if (res.status == 200) {
      this.setState({
        optionAdressData: res.data,
        showDropDown: true
      });
    }
  };
  debounce = (func, delay) => {
    let inDebounce;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  };
  
  getMessage = () => {
    return `admission date: ${moment(
      new Date(this.state.data.admissionDate)
    ).format('DD/MM/YYYY')} 
    Durée d’hospitalisation: ${this.state.data.hospitalisationDuration}
    Nature d’hospitalisation: ${this.state.data.hospitalisationNature}
    benificiaire nom: ${this.state.benificiairePicked.name}
    Nom de l’établissement:${this.state.data.facilityName}
    Email:${this.state.data.mail}
    Adresse: ${this.state.data.adresse}
    Téléphone:${this.state.data.tel}
    CP:${this.state.data.cp}
    Fax:${this.state.data.fax}
    Ville:${this.state.data.city}
    Code DMT:${this.state.data.codeDMT}
    `;
  };

  sendContact = async () => {
    const body = new FormData();
    body.append('HospitalPostalAddress.Address', this.state.data.adresse);
    body.append('HospitalPostalAddress.PostCode', this.state.data.cp);
    body.append('HospitalPostalAddress.City', this.state.data.city);
    body.append('HospitalPostalAddress.Country', 'France');

    body.append('HospitalMailPhoneFax.EmailAddress', this.state.data.mail);
    body.append('HospitalMailPhoneFax.FixPhoneNumber', this.state.data.tel);
    body.append('HospitalMailPhoneFax.Fax', this.state.data.fax);

    body.append(
      'HospitalizedPerson.FirstName',
      this.state.benificiairePicked.value?.name
    );
    body.append(
      'HospitalizedPerson.Name',
      this.state.benificiairePicked.value?.lastName
    );
    body.append(
      'HospitalizedPerson.SocialSecurityNumber',
      this.state.benificiairePicked.value?.numeroSecuriteSociale
    );

    if (this.state.benificiairePicked.value?.related === 'Spouse') {
      body.append('HospitalizedPerson.Type', 'C');
    } else if (this.state.benificiairePicked.value?.related === 'Child') {
      body.append('HospitalizedPerson.Type', 'E');
    } else {
      body.append('HospitalizedPerson.Type', 'A');
    }

    body.append(
      'AdmissionDate',
      moment(this.state.data.admissionDate).format('DD/MM/YYYY')
    );
    body.append('AdmissionDuration', this.state.data.hospitalisationDuration);
    body.append(
      'AdmissionCause',
      JSON.parse(this.state.data.hospitalisationNature).value
    );
    body.append('HospitalName', this.state.data.facilityName);

    const res = await apiSendMedicalCare(body);
    if (res.status == 200) {
      this.setState({
        currentStep: this.state.currentStep + 1
      });
      this.props.history.push({
        pathname: '/hospitalisation',
        search: `?category=${this.state.contentSquareParams[3] }`
      })
    } else {
      this.setState({
        errorMessage: res.errors[0]?.errorMessage ? res.errors[0].errorMessage :res.errors[0]
      });
    }
  };

  onChangeHospitalisationDuration = (value) => {
    const aux = { ...this.state.data };
    if (isNumber(value) || !value) {
      aux.hospitalisationDuration = value.trim();
      this.setState({
        data: aux
      });
    }
  };

  onChange = (value, key) => {
    const aux = { ...this.state.data };
    switch (key) {
      case 'hospitalisationDuration':
      case 'cp':
      case 'fax':
        if (isNumber(value) || !value) {
          aux[key] = value.trim();
        }
        break;
      case 'tel':
        if (
          !value ||
          (value.length == 1 && (value == '+' || isNumber(value.trim()))) ||
          isNumber(value.trim().slice(1))
        ) {
          aux[key] = value.trim();
        }
        break;
      default:
        aux[key] = value;
        break;
    }
    this.setState({ data: aux });
  };
  autoCompleteOptionClicked = (element) => {
    const aux = { ...this.state.data };
    this.setState({
      data: {
        ...aux,
        adresse: element.address,
        ville: element.city,
        city: element.city,
        cp: element.postCode
      },
      addressDetails: element
    });
    this.setState({
      showDropDown: false
    });
  };

  autoCompleteClickAway = () => {
    this.setState({
      showDropDown: false
    });
  };

  onHideCalender = () => {
    this.setState({ showCalendar: false });
  };

  onClickOpenCalender = () => {
    this.setState({ showCalendar: true });
  };

  beneficiairPicked = (data) => {
    this.setState({
      benificiairePicked: data,
      currentStep: this.state.currentStep + 1
    });
    this.props.history.push({
      pathname: '/hospitalisation',
      search: `?category=${this.state.contentSquareParams[this.state.currentStep] }`
    })
  };

  nextStep = () => {
    if (this.state.currentStep == 3) {
      this.sendContact();
    } else {
      this.setState({ currentStep: this.state.currentStep + 1 });
      this.props.history.push({
        pathname: '/hospitalisation',
        search: `?category=${this.state.contentSquareParams[this.state.currentStep] }`
      })
    }
  };

  prevStep = () => {
    this.setState({ currentStep: this.state.currentStep - 1 });
    this.props.history.push({
      pathname: '/hospitalisation',
      search: `?category=${this.state.contentSquareParams[this.state.currentStep] }`
    })
  };

  showNextStepBtn = () => {
    return (
      (this.state.data.mail && validateEmail(this.state.data.mail)) ||
      this.state.data.fax
    );
  };

  selectFile = (files) => {
    this.setState({
      files: files
    });
  };

  render() {
    switch (this.state.currentStep) {
      case 1:
        return (
          <HospitalisationStep1Template
            {...this.state}
            {...this}
            HospitalisationOptions={HospitalisationOptions}
          />
        );

      case 2:
        return <HospitalisationStep2Template {...this.state} {...this} />;
      case 3:
        return <HospitalisationStep3Template {...this.state} {...this} />;
      case 4:
        return <HospitalisationStep5Template {...this.state} {...this} />;
      default:
        return null;
    }
  }
}
const mapStateToProps = (state) => ({
  user: state.auth.user,
  profile: state.profile.profile
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Hospitalisation);
